const renderScoreRangeElement = (h, props) => {
    const { template } = props.resource;
    if (!template.display_score_range_labels || !template.score_range_labels) {
        return null;
    }

    const matchingRange = template.score_range_labels.find((range, index) => {
        if (index === 0) {
            return (
                props.resource.percentage >= range.min
                && props.resource.percentage <= range.max
            );
        }
        return (
            props.resource.percentage > range.min
            && props.resource.percentage <= range.max
        );
    });

    return matchingRange
        ? h(
            'div',
            {
                class: 'font-semibold text-lg',
                style: { color: matchingRange.color, marginBottom: '1px' },
            },
            matchingRange.label,
        )
        : null;
};

const boxSection = (h, { label, text }) => h('div', { class: 'flex flex-col items-start text-left' }, [
    h('span', { class: 'leading-none' }, label),
    h('div', { class: 'text-2xl font-semibold mt-3 overflow-hidden w-full' }, [
        text,
    ]),
]);

export default {
    functional: true,
    name: 'Overview',
    props: {
        negativeAnswers: {
            type: Array,
            required: true,
            default: () => [],
        },
        resource: {
            type: Object,
            required: true,
        },
    },
    render(h, { props, parent }) {
        const items = [];

        if (props.resource.template.display_score && props.resource.form.max_score) {
            const scoreText = h('div', { class: 'flex items-end flex-wrap' }, [
                h(
                    'span',
                    { class: 'mr-2' },
                    props.resource.form.max_score > 0
                        ? parent.$n(
                            props.resource.percentage / 100,
                            'scorePercentage',
                        )
                        : '-',
                ),
                renderScoreRangeElement(h, props),
            ]);

            items.push(
                boxSection(h, {
                    label: parent.$t('Total result'),
                    text: scoreText,
                }),
            );
        }

        if (props.resource.template.display_negative_answers && props.negativeAnswers.length) {
            items.push(
                boxSection(h, {
                    label: parent.$t('Negative answers'),
                    text: h('span', props.negativeAnswers.length),
                }),
            );
        }

        if (props.resource.template.display_issues && props.resource.issues.length) {
            items.push(
                boxSection(h, {
                    label: parent.$t('Raised issues'),
                    text: h(
                        'span',
                        props.resource.issues ? props.resource.issues.length : 0,
                    ),
                }),
            );
        }

        if (!items.length) return null;

        return h('table', { class: 'w-full mb-3 table-fixed' }, [
            h('tbody', {}, [
                h(
                    'tr',
                    { class: 'border border-50' },
                    items.map((item) => h(
                        'td',
                        {
                            class:
                                'border border-50 text-right align-top p-2',
                        },
                        [item],
                    )),
                ),
            ]),
        ]);
    },
};
